import { Main, Dot } from "./styles";

const Loader = () => {
  return (
    <Main>
      <Dot delay="0s"/>
      <Dot delay="0.1s"/>
      <Dot delay="0.2s"/>
    </Main>
  );
};

export default Loader;
